<div class="flex flex-col w-full items-start">
  <div class="flex w-full justify-start">
    <label
      [for]="inputId"
      class="flex items-center w-[180px] h-[50px] rounded-lg cursor-pointer theme-bg-2 theme-bg-6--hover mat-elevation-z1"
      [class.opacity-50]="uploadDisabled || loading"
      [class.pointer-events-none]="uploadDisabled || loading"
    >
      <div class="flex items-center justify-center w-[100px] border-r-2">
        @if (loading) {
          <mat-spinner diameter="24"></mat-spinner>
        } @else {
          <mat-icon>cloud_upload</mat-icon>
        }
      </div>
      <div class="flex flex-col justify-center px-2 w-full">
        <p class="text-sm theme-text-1">
          <span class="font-semibold">Upload a file</span>
        </p>
      </div>
      <input
        [id]="inputId"
        #fileInput
        type="file"
        class="hidden"
        [multiple]="maxFiles === undefined || maxFiles > 1"
        (change)="onFileSelected($event)"
        [accept]="selectedAllowedType"
        [attr.aria-label]="aria"
        [disabled]="uploadDisabled || loading"
      />
    </label>
  </div>
  @if (uploadedFiles.length > 0 && showMedia) {
    <div
      class="w-full flex flex-col items-start mt-2"
      style="min-height: 60px"
    >
      @for (file of uploadedFiles; track $index) {
        <div
          class="flex items-center mt-2 justify-between align-middle w-[470px] max-w-full rounded-lg theme-bg-1 p-2"
        >
          <span>
            {{ truncateFilename(file.name, 25) }}
          </span>

          <div class="flex items-center space-x-2">
            <span>{{ formatFileSize(file.size) }}</span>
            <button type="button" (click)="removeFile($index, fileInput)">
              <mat-icon class="text-red-500 material-icons-outlined mt-1"
                >delete</mat-icon
              >
            </button>
          </div>
        </div>
      }
    </div>
  }
</div>
